module.exports = __webpack_public_path__ + "img/file-sign-ico.ff2ce65.svg";